




import { Component, Vue, Prop, Watch } from 'nuxt-property-decorator'
import noUiSlider from 'nouislider'
import 'nouislider/distribute/nouislider.min.css'

@Component<ARangeSlider>({})
export default class ARangeSlider extends Vue {
  @Prop({
    default: () => ({
      range: { min: 0, max: 100 },
      step: 10,
      start: [10, 90],
      margin: 10,
      connect: true
    })
  }) options!: noUiSlider.Options

  @Prop({
    default: () => ([ 10, 90 ])
  }) value!: number[]

  slider!: noUiSlider.noUiSlider

  mounted() {
    const el = this.$refs.slider as HTMLElement

    this.slider = noUiSlider.create(el, this.options)
    this.slider.on('update', this.onUpdate)
    this.slider.set(this.value)
  }

  @Watch('options', { deep: true, immediate: false })
  onOptionsChange(newOptions: noUiSlider.Options) {
    this.slider.updateOptions(newOptions)
  }

  // @Watch('value', { deep: true, immediate: false })
  // onValueChange(newValue: number[], oldValue: number[]) {
  //   this.slider.set(newValue)
  // }

  onUpdate(value: any) {
    this.$emit('input', [parseInt(value[0]), parseInt(value[1])])
  }
}
